import type { AddressStored } from "@jti/fe-common";

type HasRequiredBillingAddressFieldsOptions = {
  isStreetFieldCombined: boolean;
};

export const hasRequiredBillingAddressFields = (
  address: AddressStored | null,
  { isStreetFieldCombined }: HasRequiredBillingAddressFieldsOptions
) => {
  if (!address) {
    return false;
  }

  const requiredFields = [address.streetName, ...(isStreetFieldCombined ? [] : [address.streetNumber]), address.city];

  return requiredFields.every((field) => Boolean(field?.trim()));
};
